var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-multi-select", {
    attrs: {
      up: "",
      value: _vm.value,
      items: _vm.items,
      label: "Modules:",
      fancy: "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }